module.exports = __webpack_public_path__ + "static/media/AL.fea5791e.png";